import React from "react";
import { motion } from "framer-motion";
import { Star, ShieldCheck, Handshake, Zap } from "lucide-react";
import { useLang } from "@/i18n";

const points = [
  { icon: Handshake, t: { fr: "Approche humaine", nl: "Menselijke aanpak", en: "Human approach" }, d: { fr: "Un interlocuteur unique qui suit votre dossier de A à Z.", nl: "Eén aanspreekpunt dat uw dossier van A tot Z volgt.", en: "A single contact following your file from A to Z." } },
  { icon: Zap, t: { fr: "Réponse en 48h", nl: "Antwoord in 48u", en: "48h response" }, d: { fr: "Dès que votre dossier est complet, vous avez une réponse claire.", nl: "Zodra uw dossier compleet is, krijgt u een duidelijk antwoord.", en: "Once your file is complete, you get a clear answer." } },
  { icon: ShieldCheck, t: { fr: "Un courtier indépendant.", nl: "Een onafhankelijke makelaar.", en: "An independent broker." }, d: { fr: "", nl: "", en: "" } },
];

export const WhyUs = () => {
  const { t, lang } = useLang();
  return (
    <section className="relative py-24 sm:py-32 bg-[#0d2138] border-y border-white/5" data-testid="why-us">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="relative rounded-2xl overflow-hidden border border-white/10">
          <img src="https://images.unsplash.com/photo-1652509573480-a190f1c61f6d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" alt="" className="w-full h-[420px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0d2138] via-transparent to-transparent" />
          <div className="absolute bottom-5 left-5 glass rounded-xl px-4 py-3 flex items-center gap-3">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" strokeWidth={0} />)}</div>
            <span className="text-sm font-medium">Clients ravis · Depuis 2015</span>
          </div>
        </motion.div>

        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-accent px-3 py-1 text-xs font-bold mb-5">
            <Star className="w-3 h-3 fill-white" strokeWidth={0} /> DEPUIS 2015
          </div>
          <h2 className="font-display text-3xl sm:text-5xl font-bold">{t.footer.tagline.split(".")[0]}.</h2>
          <p className="mt-4 text-muted-foreground text-lg">{t.sectors.subtitle}</p>
          <div className="mt-8 space-y-4">
            {points.map(({ icon: Icon, t: pt, d }, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="flex gap-4" data-testid={`whyus-point-${i}`}>
                <div className="w-11 h-11 shrink-0 rounded-xl bg-accent/15 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-accent" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-display font-semibold">{pt[lang]}</h3>
                  {d[lang] && <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{d[lang]}</p>}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
